import { render, staticRenderFns } from "./VvhwcPopup.vue?vue&type=template&id=477def6c"
import script from "./VvhwcPopup.vue?vue&type=script&lang=js"
export * from "./VvhwcPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports